<template>
  <div class="map-container">
    <div id="community-map" style="height: 400px;"></div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';

export default {
  name: 'CommunityLocationMap',
  props: {
    latitude: {
      type: String,
      required: true
    },
    longitude: {
      type: String,
      required: true
    },
    communityName: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#FF0000'
    },
    city: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      map: null,
      marker: null,
      defaultZoom: 10,
      infoWindow: null,
      google: null
    }
  },
  async mounted() {
    const loader = new Loader({
      apiKey: 'AIzaSyC6blCqJOwCF6zO6CnAfN6m0BvDvYtMy4s',
      version: 'weekly'
    });

    try {
      this.google = await loader.load();
      this.initMap();
    } catch (error) {
      console.error('Error loading Google Maps:', error);
    }
  },
  methods: {
    initMap() {
      if (this.map || !this.google) {
        return;
      }

      const mapOptions = {
        center: {
          lat: parseFloat(this.latitude),
          lng: parseFloat(this.longitude)
        },
        zoom: this.defaultZoom,
        mapTypeId: this.google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        mapTypeControl: true,
        streetViewControl: false,
        fullscreenControl: true,
        mapTypeControlOptions: {
          position: this.google.maps.ControlPosition.TOP_LEFT,
          style: this.google.maps.MapTypeControlStyle.HORIZONTAL_BAR
        },
        zoomControlOptions: {
          position: this.google.maps.ControlPosition.RIGHT_BOTTOM
        },
        fullscreenControlOptions: {
          position: this.google.maps.ControlPosition.RIGHT_TOP
        }
      };

      this.map = new this.google.maps.Map(
        document.getElementById('community-map'),
        mapOptions
      );

      // Create marker
      this.marker = new this.google.maps.Marker({
        position: {
          lat: parseFloat(this.latitude),
          lng: parseFloat(this.longitude)
        },
        map: this.map,
        icon: {
          path: this.google.maps.SymbolPath.MARKER,
          fillColor: this.color,
          fillOpacity: 1,
          strokeWeight: 0,
          scale: 12
        }
      });

      // Create info window
      this.infoWindow = new this.google.maps.InfoWindow({
        content: this.getInfoWindowContent()
      });

      this.marker.addListener('click', () => {
        this.infoWindow.open(this.map, this.marker);
      });

      // Open info window by default
      this.infoWindow.open(this.map, this.marker);
    },

    getInfoWindowContent() {
      return `
        <div style="padding: 8px; color: #000000; font-family: Arial, sans-serif; min-width: 150px;">
          <strong style="font-size: 14px; color: #000000; display: block; margin-bottom: 4px;">
            ${this.communityName}
          </strong>
          ${this.city || this.state || this.country ?
            `<span style="color: #000000; font-size: 13px;">
              ${[this.city, this.state, this.country].filter(Boolean).join(', ')}
            </span>`
            : ''}
        </div>
      `
    }
  },
  watch: {
    latitude(newVal) {
      if (this.map && this.marker && newVal) {
        const position = { lat: parseFloat(newVal), lng: parseFloat(this.longitude) }
        this.marker.setPosition(position)
        this.map.setCenter(position)
      }
    },
    longitude(newVal) {
      if (this.map && this.marker && newVal) {
        const position = { lat: parseFloat(this.latitude), lng: parseFloat(newVal) }
        this.marker.setPosition(position)
        this.map.setCenter(position)
      }
    },
    communityName() {
      if (this.infoWindow) {
        this.infoWindow.setContent(this.getInfoWindowContent())
      }
    },
    city() {
      if (this.infoWindow) {
        this.infoWindow.setContent(this.getInfoWindowContent())
      }
    },
    state() {
      if (this.infoWindow) {
        this.infoWindow.setContent(this.getInfoWindowContent())
      }
    },
    country() {
      if (this.infoWindow) {
        this.infoWindow.setContent(this.getInfoWindowContent())
      }
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map = null;
      this.marker = null;
      this.infoWindow = null;
    }
  }
}
</script>

<style>
.map-container {
  position: relative;
  width: 100%;
  height: 400px;
  font-family: Arial, sans-serif;
}

#community-map {
  width: 100%;
  height: 100%;
}
</style>